import React, {useState} from 'react';

import styles from './ForgotPasswordStep3.module.scss';
import logo from "../../constants/images/logo.svg";
import ReturnToLoginPage from "../../components/UI/ReturnToLoginPage/ReturnToLoginPage";
import {useNavigate, useParams} from "react-router-dom";
import {joiResolver} from "@hookform/resolvers/joi";
import {passwordRecoveryValidator} from "../../validators/passwordRecovery.validator";
import {useForm} from "react-hook-form";
import {Box, CircularProgress} from "@mui/material";
import {MAIN_ROUTES} from "../../routing/main_routes";
import {axiosService} from "../../services/axios.service";
import {endPoints as endpoints} from "../../configs/urls";

const ForgotPasswordStep3 = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isPasswordChanged, setIsPasswordChanged] = useState(false);

  const {token} = useParams();

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: {errors, isValid},
  } = useForm({
    mode: "all",
    resolver: joiResolver(passwordRecoveryValidator),
  });

  const handleResetPassword = async (data) => {
    const {password, confirm_password} = data;

    try {
      setIsLoading(true);

      const res = await axiosService.post(endpoints.passwordRecovery.setNewPassword, {
        password,
        confirm_password,
        token,
      });

      if (res.status === 200) {
        setIsPasswordChanged(true);
      }

      setTimeout(() => {
        navigate(MAIN_ROUTES.FORGOT_PASSWORD_STEP_4);
      }, 3000);
    } catch (e) {
        setError(JSON.stringify(e?.response?.data || e?.message || e));
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className={styles.forgotPasswordStep3_wrapper}>
      <div className={styles.forgotPasswordStep3_wrapper_forgotPasswordStep3}>
        <div className={styles.forgotPasswordStep3_wrapper_forgotPasswordStep3_title}>
          <img src={logo} alt="quality cleaning logo"/>

          <div>
            <h1 className={styles.title}>Встановити новий пароль</h1>
            <p className={styles.paragraph}>Ваш новий пароль має відрізнятися від паролів, які
              використовувалися раніше.</p>
          </div>
        </div>

        <form onSubmit={handleSubmit(handleResetPassword)} action="#"
              className={styles.forgotPasswordStep3_wrapper_forgotPasswordStep3_form}>
          <label>
            Пароль
            <input
              className={styles.input}
              {...register("password")}
              type="password"
            />
            {errors.password && <span className={styles.error}> {errors.password.message} </span>}
          </label>

          <label>
            Повторити пароль
            <input
              className={styles.input}
              {...register("confirm_password")}
              type="password"
            />
            {errors.confirm_password && <span className={styles.error}> {errors.confirm_password.message} </span>}
            {error && <span className={styles.error}> {error} </span>}
          </label>

          {!isPasswordChanged &&
            <>{isLoading ?
              <Box sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                <CircularProgress style={{color: "#405BD8"}}/>
              </Box> :
              <button
                type={"submit"}
                className={styles.forgotPasswordStep3_wrapper_forgotPasswordStep3_form_button}
                disabled={!isValid}
              >Скинути пароль
              </button>}</>}
        </form>

        <ReturnToLoginPage/>
      </div>
    </div>
  );
};

export default ForgotPasswordStep3;
